module.exports = __webpack_public_path__ + "static/media/deleteIcon.d87b079f.svg";